import _ from 'lodash';
import * as type from './types';
export default (state = [], action) => {
  switch (action.type) {
    case type.FETCH_COMPANIES:
      return { ..._.mapKeys(action.payload, 'id') };
    case type.FETCH_COMPANY:
      return { ...state, [action.payload.id]: action.payload };
    case type.CREATE_COMPANY:
      return { ...state, [action.payload.id]: action.payload };
    case type.EDIT_COMPANY:
      return { ...state, [action.payload.id]: action.payload };
    case type.DELETE_COMPANY:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
